define("shared/components/shared/post/media/side-library", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.hasMediaItems}}
    <Shared::MediaLibrary @filterImages={{@filterImages}} />
  {{else}}
    <div class="cLIB--board eLib--board cCM--mediaLibrary" data-test-id="no-media-state">
      <div class="cLIB--boardHeader__upload">
        <Shared::AssetUpload @dropDisabled={{true}} @location="post_modal" />
      </div>
      <div class="cCM--mediaLibrary__empty">
        <div class="img--empty__sidelib"></div>
        <div class="o--blank">
          <h3 class="o--blank__title">
            {{t "post.change_media.empty.title"}}
          </h3>
          <p class="o--blank__desc u--m__b__xs">
            {{t "post.change_media.empty.description"}}
          </p>
          <div class="u--m__b">
            <Shared::Ui::Button
              @additional="block"
              @onClick={{this.browse}}
              @text={{t "media_items.new.from_computer"}}
              @variant="actionLink"
              data-test-id="computer-upload"
            />
            <Shared::Ui::Button
              @additional="block"
              @onClick={{this.openGooglePicker}}
              @text={{t "media_items.new.from_google"}}
              @variant="actionLink"
              data-test-id="google-drive"
            />
            <Shared::Ui::Button
              @additional="block"
              @onClick={{this.openDropbox}}
              @text={{t "media_items.new.from_dropbox"}}
              @variant="actionLink"
              data-test-id="dropbox"
            />
          </div>
          <p class="o--blank__desc u--m__b__xs">
            {{t "post.change_media.empty.no_media"}}
          </p>
          <div class="u--m__b">
            <Shared::Ui::Button
              @additional="block"
              @class=""
              @onClick={{perform this.addTestImage}}
              @text={{t "post.change_media.empty.test_image"}}
              @variant="actionLink"
              data-test-id="test-image"
            />
          </div>
        </div>
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "g6SE7EgC",
    "block": "[[[41,[30,0,[\"hasMediaItems\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@filterImages\"],[[30,1]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[14,0,\"cLIB--board eLib--board cCM--mediaLibrary\"],[14,\"data-test-id\",\"no-media-state\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cLIB--boardHeader__upload\"],[12],[1,\"\\n      \"],[8,[39,2],null,[[\"@dropDisabled\",\"@location\"],[true,\"post_modal\"]],null],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"cCM--mediaLibrary__empty\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"img--empty__sidelib\"],[12],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n        \"],[10,\"h3\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"post.change_media.empty.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc u--m__b__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"post.change_media.empty.description\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--m__b\"],[12],[1,\"\\n          \"],[8,[39,4],[[24,\"data-test-id\",\"computer-upload\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"browse\"]],[28,[37,3],[\"media_items.new.from_computer\"],null],\"actionLink\"]],null],[1,\"\\n          \"],[8,[39,4],[[24,\"data-test-id\",\"google-drive\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"openGooglePicker\"]],[28,[37,3],[\"media_items.new.from_google\"],null],\"actionLink\"]],null],[1,\"\\n          \"],[8,[39,4],[[24,\"data-test-id\",\"dropbox\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"openDropbox\"]],[28,[37,3],[\"media_items.new.from_dropbox\"],null],\"actionLink\"]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc u--m__b__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"post.change_media.empty.no_media\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--m__b\"],[12],[1,\"\\n          \"],[8,[39,4],[[24,\"data-test-id\",\"test-image\"]],[[\"@additional\",\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",\"\",[28,[37,5],[[30,0,[\"addTestImage\"]]],null],[28,[37,3],[\"post.change_media.empty.test_image\"],null],\"actionLink\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"@filterImages\"],false,[\"if\",\"shared/media-library\",\"shared/asset-upload\",\"t\",\"shared/ui/button\",\"perform\"]]",
    "moduleName": "shared/components/shared/post/media/side-library.hbs",
    "isStrictMode": false
  });
  let SideLibraryComponent = _exports.default = (_class = class SideLibraryComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dropbox", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "googlePicker", _descriptor4, this);
      _initializerDefineProperty(this, "onboarding", _descriptor5, this);
      _initializerDefineProperty(this, "store", _descriptor6, this);
      _defineProperty(this, "addTestImage", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.onboarding.addTestImage.perform();
        }
      }), null, "addTestImage", null));
    }
    get hasMediaItems() {
      const mediaItems = this.store.peekAll('media-item').filter(mediaItem => {
        return mediaItem.group.get('id') === this.auth.currentGroup.id;
      });
      return mediaItems.length > 0;
    }
    browse() {
      const input = document.querySelector('input[type=file]');
      if (input) {
        input.click();
      } else {
        this.errors.log('No input element found when attempting upload');
      }
    }
    openDropbox() {
      this.dropbox.openDropbox();
    }
    openGooglePicker() {
      this.googlePicker.createPicker().catch(error => this.errors.log(error));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dropbox", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "googlePicker", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "browse", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "browse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openDropbox", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openDropbox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openGooglePicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openGooglePicker"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SideLibraryComponent);
});